import Enums from "../enums/enums";
import * as allFunction from "../function/allFunction";
import i18n from "../locales/i18n";

const packagePriceConstant = {
  basic1M_Old: 500,
  basic3M_Old: 1350,
  basic12M_Old: 4800,
  pro1M_Old: 700,
  pro3M_Old: 1890,
  pro12M_Old: 6720,
  proPlus1M_Old: 1200,
  proPlus3M_Old: 3240,
  proPlus12M_Old: 11520,

  basic1M_New: 500,
  basic3M_New: 1500,
  basic12M_New: 5000,
  pro1M_New: 900,
  pro3M_New: 2500,
  pro12M_New: 9000,
  proPlus1M_New: 1200,
  proPlus3M_New: 3500,
  proPlus12M_New: 12000,
  ledger1M_New: 250,
  ledger3M_New: 750,
  ledger12M_New: 3000,
  accountant1M_New: 300,
  accountant3M_New: 900,
  accountant12M_New: 3600,
};

const packageOriginalPriceConstant = {
  basic1M_Old: 500,
  basic3M_Old: 1500,
  basic12M_Old: 6000,
  pro1M_Old: 700,
  pro3M_Old: 2100,
  pro12M_Old: 8400,
  proPlus1M_Old: 1200,
  proPlus3M_Old: 3600,
  proPlus12M_Old: 14400,

  basic1M_New: 500,
  basic3M_New: 1500,
  basic12M_New: 6000,
  pro1M_New: 900,
  pro3M_New: 2700,
  pro12M_New: 10800,
  proPlus1M_New: 1200,
  proPlus3M_New: 3600,
  proPlus12M_New: 14400,
  ledger1M_New: 250,
  ledger3M_New: 750,
  ledger12M_New: 3000,
  accountant1M_New: 300,
  accountant3M_New: 900,
  accountant12M_New: 3600,
};

function GetNewPeakPackageAmount(peakPackage, packagePeriodMonth) {
  let packageAmount = 0.0;

  switch (peakPackage) {
    case Enums.Package.Basic:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packagePriceConstant.basic1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packagePriceConstant.basic3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packagePriceConstant.basic12M_New;
      }
      break;
    case Enums.Package.Pro:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packagePriceConstant.pro1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packagePriceConstant.pro3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packagePriceConstant.pro12M_New;
      }
      break;
    case Enums.Package.ProPlus:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packagePriceConstant.proPlus1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packagePriceConstant.proPlus3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packagePriceConstant.proPlus12M_New;
      }
      break;
    case Enums.Package.AFPLedger:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packagePriceConstant.ledger1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packagePriceConstant.ledger3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packagePriceConstant.ledger12M_New;
      }
      break;
    case Enums.Package.AFPAccountant:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packagePriceConstant.accountant1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packagePriceConstant.accountant3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packagePriceConstant.accountant12M_New;
      }
      break;
  }

  return packageAmount;
}
function GetNewPeakPackageOriginalAmount(peakPackage, packagePeriodMonth) {
  let packageAmount = 0.0;

  switch (peakPackage) {
    case Enums.Package.Basic:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packageOriginalPriceConstant.basic1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packageOriginalPriceConstant.basic3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packageOriginalPriceConstant.basic12M_New;
      }
      break;
    case Enums.Package.Pro:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packageOriginalPriceConstant.pro1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packageOriginalPriceConstant.pro3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packageOriginalPriceConstant.pro12M_New;
      }
      break;
    case Enums.Package.ProPlus:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packageOriginalPriceConstant.proPlus1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packageOriginalPriceConstant.proPlus3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packageOriginalPriceConstant.proPlus12M_New;
      }
      break;
    case Enums.Package.AFPLedger:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packageOriginalPriceConstant.ledger1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packageOriginalPriceConstant.ledger3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packageOriginalPriceConstant.ledger12M_New;
      }
      break;
    case Enums.Package.AFPAccountant:
      if (packagePeriodMonth === Enums.PackageMonth.OneMonth) {
        packageAmount = packageOriginalPriceConstant.accountant1M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.ThreeMonth) {
        packageAmount = packageOriginalPriceConstant.accountant3M_New;
      } else if (packagePeriodMonth === Enums.PackageMonth.TwelveMonth) {
        packageAmount = packageOriginalPriceConstant.accountant12M_New;
      }
      break;
  }

  return packageAmount;
}
export default {
  GetPeakPackageAmount(peakPackage, packagePeriodMonth, isOriginal = false) {
    return isOriginal
      ? GetNewPeakPackageOriginalAmount(peakPackage, packagePeriodMonth)
      : GetNewPeakPackageAmount(peakPackage, packagePeriodMonth);
  },
  GetPeakPackageIncludeVatAmount(peakPackage, packagePeriodMonth, isOriginal = false) {
    let packageAmount = this.GetPeakPackageAmount(peakPackage, packagePeriodMonth, isOriginal);
    let vatAmount = packageAmount * 0.07;
    return packageAmount + vatAmount;
  },
  GetUpgradePayment(packagePayment, promoCodeDetail, isPromoCode) {
    let paymentAmount = 0.0;
    let discountAmount = 0.0;
    let whtAmount = 0.0;

    let packageAmount = this.GetPeakPackageAmount(packagePayment.package.value.id, packagePayment.period.value.id);
    if (promoCodeDetail && isPromoCode) {
      switch (promoCodeDetail.campaign.campaignType) {
        case Enums.PromoCampaign.Discount:
          discountAmount =
            promoCodeDetail.campaign.discountAmount + (promoCodeDetail.campaign.discountPercent * packageAmount) / 100;
          paymentAmount = packageAmount >= discountAmount ? packageAmount - discountAmount : 0;
          packagePayment.month = packagePayment.period.value.id;
          break;
        case Enums.PromoCampaign.Package:
          if (
            packagePayment.package.value.id == promoCodeDetail.campaign.packageId &&
            ((packagePayment.packagePeriodType == Enums.PackagePeriodType.Month &&
              packagePayment.month == promoCodeDetail.campaign.packagePeriod) ||
              (packagePayment.packagePeriodType == Enums.PackagePeriodType.Day &&
                packagePayment.day == promoCodeDetail.campaign.packagePeriodDay) ||
              (packagePayment.packagePeriodType == Enums.PackagePeriodType.ExpiredDate &&
                packagePayment.expiredDate == promoCodeDetail.campaign.packageExpiredDate))
          ) {
            packageAmount = promoCodeDetail.campaign.packagePrice;
            paymentAmount = packageAmount;

            packagePayment.month = promoCodeDetail.campaign.packagePeriod;
            packagePayment.day = promoCodeDetail.campaign.packagePeriodDay;
            packagePayment.expiredDate = promoCodeDetail.campaign.packageExpiredDate;
          }
          break;
        case Enums.PromoCampaign.Extra:
          paymentAmount = packagePayment.packagePeriodType === Enums.PackagePeriodType.Month ? packageAmount : 0;
          packagePayment.month = packagePayment.period.value.id;
          break;
      }
    } else {
      paymentAmount = packagePayment.packagePeriodType === Enums.PackagePeriodType.Month ? packageAmount : 0;
      packagePayment.month = packagePayment.period.value.id;
    }
    let vatAmount = paymentAmount * 0.07;
    switch (packagePayment.wht.value) {
      case Enums.WhtAmountType.ThreePercent.type:
        whtAmount = paymentAmount * 0.03;
        break;
      case Enums.WhtAmountType.OnePercent.type:
        whtAmount = paymentAmount * 0.01;
        break;
      case Enums.WhtAmountType.None.type:
      default:
        whtAmount = 0;
        break;
    }
    let packagePaymentAmount = paymentAmount - whtAmount + vatAmount;

    packagePayment.price = packageAmount;
    packagePayment.paymentAmount = packagePaymentAmount < 0 ? 0 : packagePaymentAmount;
    packagePayment.discountAmount = discountAmount;
    packagePayment.whtAmount = whtAmount;
    packagePayment.vatAmount = vatAmount;

    return packagePayment;
  },
  GetSummaryPackagePayment() {
    let summaryPackage = {
      subscriptionType: {
        value: Enums.SubscriptionType.AutoSubscription,
        name: i18n.t("Auto_Subscription"),
      },
      packagePaymentType: Enums.PackagePaymentType.QRCode,
      package: {
        value: {
          id: 0,
          name: "",
        },
        disable: false,
      },
      period: {
        value: {
          id: 0,
          name: "",
        },
        disable: false,
        isHidden: false,
      },
      peroidForPromoCode: "",
      packagePeriodType: Enums.PackagePeriodType.Month,
      month: Enums.PackageMonth.TwelveMonth,
      day: 0,
      expiredDate: "",
      newExpireDate: "",
      wht: {
        name: i18n.t("WHT_None"),
        value: Enums.WhtAmountType.None.type,
      },
      price: 0.0,
      discountAmount: 0.0,
      vatAmount: 0.0,
      whtAmount: 0.0,
      paymentAmount: 0.0,
      transferPayment: {
        date: {
          value: "",
          validateError: false,
        },
        memo: {
          value: "",
          validateError: false,
        },
        time: {
          value: "",
          validateError: false,
        },
        fileList: [],
      },
      omiseCardCharge: {
        token: "",
        type: Enums.ChargeTokenType.CardToken,
      },
    };
    return summaryPackage;
  },
  GetPackageName(packageId) {
    let packageName = "";
    switch (packageId) {
      case Enums.Package.Trial:
        packageName = "TRIAL";
        break;
      case Enums.Package.Free:
        packageName = "FREE";
        break;
      case Enums.Package.Basic:
        packageName = "BASIC";
        break;
      case Enums.Package.Pro:
        packageName = "PRO";
        break;
      case Enums.Package.ProPlus:
        packageName = "PRO Plus";
        break;
      case Enums.Package.AFPFree:
        packageName = "AFP FREE";
        break;
      case Enums.Package.AFPLedger:
        packageName = "LEDGER";
        break;
      case Enums.Package.AFPAccountant:
        packageName = "ACCOUNTANT";
        break;
    }
    return packageName;
  },
  GetPackageColorClass(packageId) {
    let colorClass = "";
    switch (packageId) {
      case Enums.Package.Basic:
        colorClass = "basicColor";
        break;
      case Enums.Package.Pro:
        colorClass = "proColor";
        break;
      case Enums.Package.ProPlus:
        colorClass = "proPlusColor";
        break;
      case Enums.Package.AFPLedger:
        colorClass = "ledgerColor";
        break;
      case Enums.Package.AFPAccountant:
        colorClass = "accountantColor";
        break;
    }
    return colorClass;
  },
  GetPackageColorTextClass(packageId) {
    let colorClass = "";
    switch (packageId) {
      case Enums.Package.Basic:
        colorClass = "basicColorText";
        break;
      case Enums.Package.Pro:
        colorClass = "proColorText";
        break;
      case Enums.Package.ProPlus:
        colorClass = "proPlusColorText";
        break;
      case Enums.Package.AFPLedger:
        colorClass = "ledgerColorText";
        break;
      case Enums.Package.AFPAccountant:
        colorClass = "accountantColorText";
        break;
    }
    return colorClass;
  },
  GetPackageColorButton(packageId) {
    let colorClass = "";
    switch (packageId) {
      case Enums.Package.Basic:
        colorClass = "soft-blue";
        break;
      case Enums.Package.Pro:
        colorClass = "blue";
        break;
      case Enums.Package.ProPlus:
        colorClass = "blue-gradient";
        break;
      case Enums.Package.AFPLedger:
        colorClass = "purple-ledger";
        break;
      case Enums.Package.AFPAccountant:
        colorClass = "mint";
        break;
    }
    return colorClass;
  },
  GetIconCreditCardBrand(brand) {
    let iconClass = "";

    switch (brand) {
      case Enums.CreditCardBrand.MasterCard:
        iconClass = "mastercard";
        break;
      case Enums.CreditCardBrand.Visa:
        iconClass = "visa";
        break;
      case Enums.CreditCardBrand.Jcb:
        iconClass = "jcb";
        break;
      default:
        iconClass = "default";
        break;
    }

    return iconClass;
  },
  GetPaymentStatusDetail(subscriptionHistory) {
    let statusDetail = "";

    if (subscriptionHistory.isCancelled === Enums.isCancelled.NoSuccess) {
      subscriptionHistory.paymentStatus = Enums.paymentStatus.Fail;
    }
    switch (subscriptionHistory.paymentStatus) {
      case Enums.paymentStatus.Processing:
        statusDetail = i18n.t("Processing_Payment_Tooltip");
        break;
      case Enums.paymentStatus.Fail:
        statusDetail = [
          { content: i18n.t("Fail_Payment_One_Time_Tooltip") },
          { content: i18n.t("Fail_Payment_Auto_Tooltip") },
        ];
        break;
    }
    return statusDetail;
  },
  GetPackageErrorDescription(promoCodeErrorData, isPayment = false) {
    let packageError = "";

    if (promoCodeErrorData && promoCodeErrorData.packageErrorCode) {
      switch (promoCodeErrorData.packageErrorCode) {
        case Enums.PackageErrorCode.PromoCodeUsed:
          packageError = i18n.t("Promo_Code_Quota_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeInvalidMerchantChecked:
          packageError = i18n.t("Promo_Code_Unique_Merchant_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeInvalidUserChecked:
          packageError = i18n.t("Promo_Code_Unique_User_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeExpired:
          packageError = i18n.t("PromoCode_Expired");
          break;
        case Enums.PackageErrorCode.InvalidUpgradeToPackage:
          packageError = i18n.t("Invalid_Upgrade_To_Package");
          break;
        case Enums.PackageErrorCode.PromoCodeUnpaidMerchantChecked:
          packageError = i18n.t("Promo_Code_Unpaid_Merchant_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeUserEmailChecked:
        case Enums.PackageErrorCode.PromoCodeFixUser:
          packageError = i18n.t("Promo_Code_User_Email_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeStarted:
          packageError = i18n.t("Promo_Code_Start_Date_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeFixMerchant:
          packageError = i18n.t("Promo_Code_Merchant_Id_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeFixClient:
          packageError = i18n.t("Promo_Code_API_Client_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeFixFirm:
          packageError = i18n.t("Promo_Code_Firm_Checked");
          break;
        case Enums.PackageErrorCode.PromoCodeRegisterType:
          packageError = i18n.t("Promo_Code_Rerister_Type_Checked");
          break;
        case Enums.PackageErrorCode.OmiseChargedFail:
          packageError = i18n.t("Package_Error_Omise_Charged_Fail");
          break;
        case Enums.PackageErrorCode.ScbQrPaymentUnpaid:
          packageError = i18n.t("Package_Error_Payment_Unpaid");
          break;
        case Enums.PackageErrorCode.InvalidPaymentAmount:
          packageError = i18n.t("Package_Error_Invalid_Payment_Amount");
          break;
        case Enums.PackageErrorCode.InvalidDiscountAmount:
          packageError = i18n.t("Package_Error_Invalid_Discount_Amount");
          break;
        case Enums.PackageErrorCode.InvalidWhtAmount:
          packageError = i18n.t("Package_Error_Invalid_Wht_Amount");
          break;
        case Enums.PackageErrorCode.MerchantPackageInvalid:
          packageError = i18n.t("Package_Error_Invalid_Package_Type", {
            package: this.GetPackageName(promoCodeErrorData.erroData.packageType),
          });
          break;
        case Enums.PackageErrorCode.PackagePeriodInvalid:
          packageError = promoCodeErrorData.erroData.isAFP
            ? i18n.t("Period_Invalid_Promo_Code_AFP")
            : i18n.t("Invalid_Promo_Code");
          break;
        default:
          packageError = isPayment ? i18n.t("Package_Error_Payment_Unpaid") : i18n.t("Invalid_Promo_Code");
          break;
      }
    } else {
      packageError = isPayment ? i18n.t("Package_Error_Payment_Unpaid") : i18n.t("Invalid_Promo_Code");
    }

    return packageError;
  },
  SetPackageInfoForPromoCodePackageType(packagePayment, promoCodeDetail, packageList) {
    let summaryPackagePayment = packagePayment;

    if (promoCodeDetail.campaign.packageId > 0) {
      summaryPackagePayment.package.value = packageList.find((x) => x.id === promoCodeDetail.campaign.packageId);
      summaryPackagePayment.package.disable = true;
      summaryPackagePayment.period.isHidden = true;

      if (promoCodeDetail.campaign.packagePeriod > 0) {
        // Fix month
        summaryPackagePayment.packagePeriodType = Enums.PackagePeriodType.Month;
        summaryPackagePayment.month = promoCodeDetail.campaign.packagePeriod;
        summaryPackagePayment.peroidForPromoCode = summaryPackagePayment.month + " " + i18n.t("Setting_Number_Month");
      } else if (promoCodeDetail.campaign.packagePeriodDay > 0) {
        // Fix day
        summaryPackagePayment.packagePeriodType = Enums.PackagePeriodType.Day;
        summaryPackagePayment.day = promoCodeDetail.campaign.packagePeriodDay;
        summaryPackagePayment.peroidForPromoCode = summaryPackagePayment.day + " " + i18n.t("Days");
      } else {
        // Fix expired date
        summaryPackagePayment.packagePeriodType = Enums.PackagePeriodType.ExpiredDate;
        summaryPackagePayment.expiredDate = promoCodeDetail.campaign.packageExpiredDate;
        summaryPackagePayment.peroidForPromoCode =
          i18n.t("Expried") + " " + allFunction.setDateFormat(summaryPackagePayment.expiredDate);
      }
    }
    return summaryPackagePayment;
  },
  SetPackageInfoForPromoCodeDiscountType(packagePayment, promoCodeDetail, packageList) {
    let summaryPackagePayment = packagePayment;

    if (promoCodeDetail.campaign.packageId > 0) {
      // Fix package
      summaryPackagePayment.package.value = packageList.find((x) => x.id === promoCodeDetail.campaign.packageId);
      summaryPackagePayment.package.disable = true;
    }
    if (promoCodeDetail.campaign.packagePeriod > 0) {
      // Fix period
      summaryPackagePayment.period.value.id = promoCodeDetail.campaign.packagePeriod;
      summaryPackagePayment.period.disable = true;
    }

    return summaryPackagePayment;
  },
  SetPackageInfoForPromoCodeExtraType(packagePayment, promoCodeDetail, packageList) {
    let summaryPackagePayment = packagePayment;

    summaryPackagePayment.packagePeriodType = Enums.PackagePeriodType.Month;
    summaryPackagePayment.month = promoCodeDetail.campaign.packagePeriod;
    summaryPackagePayment.peroidForPromoCode =
      summaryPackagePayment.month +
      " " +
      i18n.t("Setting_Number_Month") +
      " " +
      i18n.t("Extra_Free") +
      " " +
      promoCodeDetail.campaign.packagePeriodExtra;

    if (promoCodeDetail.campaign.packageId > 0) {
      summaryPackagePayment.package.value = packageList.find((x) => x.id === promoCodeDetail.campaign.packageId);
      summaryPackagePayment.package.disable = true;
    }

    if (promoCodeDetail.campaign.packagePeriod > 0) {
      summaryPackagePayment.period.value.id = promoCodeDetail.campaign.packagePeriod;
      summaryPackagePayment.period.disable = true;
    }

    return summaryPackagePayment;
  },
  SetNewExpireDatePackage(summaryPackagePayment, packageDetail) {
    let newExpireDate = "";
    if (
      summaryPackagePayment.package.value.id === packageDetail.peakPackage ||
      packageDetail.peakPackage === Enums.Package.Trial
    ) {
      newExpireDate = packageDetail.expireDateTime;
    } else {
      newExpireDate = this.CalculateNewExpireDateUpgrade(packageDetail, summaryPackagePayment.package.value.id);
    }
    return newExpireDate;
  },
  SetNewExpireDatePackageForPromoCode(summaryPackagePayment, promoCodeDetail, date) {
    const expireDate = new Date(date);
    let newExpireDate = expireDate;

    if (promoCodeDetail.campaign.campaignType === Enums.PromoCampaign.Package) {
      if (promoCodeDetail.campaign.packagePeriod > 0) {
        newExpireDate = new Date(expireDate.setMonth(expireDate.getMonth() + promoCodeDetail.campaign.packagePeriod));
      } else if (promoCodeDetail.campaign.packagePeriodDay > 0) {
        newExpireDate = new Date(expireDate.setDate(expireDate.getDate() + promoCodeDetail.campaign.packagePeriodDay));
      } else {
        newExpireDate = summaryPackagePayment.expiredDate;
      }
    }
    return newExpireDate;
  },

  CalculateNewExpireDateUpgrade(packageDetail, upgragePackageId) {
    let expireDate = new Date(packageDetail.expireDateTime);
    let dateTime = packageDetail.isTrialPackage ? new Date(packageDetail.trialPackageExpireDateTime) : new Date();

    expireDate = new Date(expireDate.getFullYear(), expireDate.getMonth(), expireDate.getDate());
    dateTime = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

    let remainTime = expireDate.getTime() - dateTime.getTime();
    let remainDays = remainTime / (1000 * 3600 * 24);
    let remainNewDays = 0;
    let currentPackageAmount = this.GetPeakPackageAmount(packageDetail.peakPackage, Enums.PackageMonth.OneMonth);
    let upgragePackageAmount = this.GetPeakPackageAmount(upgragePackageId, Enums.PackageMonth.OneMonth);

    remainNewDays = Math.ceil(remainDays * (currentPackageAmount / upgragePackageAmount));

    dateTime.setDate(dateTime.getDate() + remainNewDays);
    return dateTime;
  },
  CalculateTimeForCountDownExpirePackage() {
    let toDate = new Date();
    let tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    let diffMS = tomorrow.getTime() / 1000 - toDate.getTime() / 1000;
    let diffHr = Math.floor(diffMS / 3600);
    diffMS = diffMS - diffHr * 3600;
    let diffMi = Math.floor(diffMS / 60);
    diffMS = diffMS - diffMi * 60;
    let hours = diffHr < 10 ? "0" + diffHr : diffHr;
    return hours + ":" + (diffMi < 10 ? "0" + diffMi : diffMi);
  },
  ConvertToUpgradePackage(summarizePricePackage, promoCodeDetail) {
    if (summarizePricePackage.month > 0 || summarizePricePackage.day > 0) {
      summarizePricePackage.expiredDate = "";
    }
    let upgradePackage = {
      packagePeriodType: summarizePricePackage.packagePeriodType,
      package: summarizePricePackage.package.value.id,
      month: summarizePricePackage.month,
      day: summarizePricePackage.day,
      expiredDate: summarizePricePackage.expiredDate ? summarizePricePackage.expiredDate.ToDateJsonString() : "",
      packagePrice:
        summarizePricePackage.paymentAmount + summarizePricePackage.whtAmount + summarizePricePackage.discountAmount,
      monthExtra: promoCodeDetail ? promoCodeDetail.campaign.packagePeriodExtra : 0,
    };
    return upgradePackage;
  },
  ConvertToUpgradePayment(summarizePricePackage, promoCode, paymentNote = "") {
    let upgradePayment = {
      paymentDateTime: new Date().ToDateJsonString(),
      paymentNote: paymentNote,
      whtType: summarizePricePackage.wht.value,
      promoCode: promoCode ? promoCode.promoCode.code : "",
      paymentAmount: summarizePricePackage.paymentAmount,
      discountAmount: summarizePricePackage.discountAmount,
      whtAmount: summarizePricePackage.whtAmount,
    };
    return upgradePayment;
  },
  ConvertCreditCardBrand(brandStr) {
    let brand = Enums.CreditCardBrand.None;

    switch (brandStr.toLowerCase()) {
      case "mastercard":
        brand = Enums.CreditCardBrand.MasterCard;
        break;
      case "visa":
        brand = Enums.CreditCardBrand.Visa;
        break;
      case "jcb":
        brand = Enums.CreditCardBrand.Jcb;
        break;
      default:
        brand = Enums.CreditCardBrand.Other;
        break;
    }

    return brand;
  },
};
